import React from 'react';
import PropTypes from 'prop-types';
import { createIntl, createIntlCache, RawIntlProvider } from 'react-intl';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

import SplashRoutes from 'splash/routes';
import { ErrorMessage } from 'splash/components';
import { getInitParams } from 'utils';
import { getI18nMessages, getI18nKebbabFormat } from 'utils/i18n';

import defaultTheme from 'basicTheme';

const { language } = getInitParams();
const I18nKebbabFormatLanguage = getI18nKebbabFormat(language);

const cacheIntl = createIntlCache();
const intl = createIntl(
  {
    locale: I18nKebbabFormatLanguage,
    messages: getI18nMessages(language),
  },
  cacheIntl,
);

const Root = ({ type, hideThumbnail, logoUrl }) => (
  <RawIntlProvider value={intl}>
    <MuiThemeProvider theme={defaultTheme}>
      <CssBaseline />
      {type === 'error' ? (
        <ErrorMessage />
      ) : (
        <SplashRoutes hideThumbnail={hideThumbnail} logoUrl={logoUrl} />
      )}
    </MuiThemeProvider>
  </RawIntlProvider>
);

Root.propTypes = {
  type: PropTypes.string,
  hideThumbnail: PropTypes.bool,
  logoUrl: PropTypes.string,
};

Root.defaultProps = {
  type: '',
  hideThumbnail: false,
  logoUrl: null,
};

export default Root;
